import fetch from "auth/FetchInterceptor";

const CollateralCustomerService = {};

CollateralCustomerService.posCollateralCustomerService = function (data) {
  return fetch({
    url: `/CollateralCustomer/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

CollateralCustomerService.getCollateralCustomerService = function (data) {
  const pageIndex = data.pageIndex ?? 0;
  const actualIndex = pageIndex > 0 ? pageIndex - 1 : 0;

  const params = new URLSearchParams();

  params.append("pageSize", data.pageSize ?? 10);
  params.append("pageIndex", actualIndex);

  if (data?.collateralId) params.append("collateralId", data.collateralId);
  if (data?.collateralType) params.append("collateralType", data.collateralType);
  if (data?.ownerName) params.append("ownerName", data.ownerName);
  if (data?.jenisPengikatan) params.append("jenisPengikatan", data.jenisPengikatan);
  if (data?.cifNo) params.append("cifNo", data.cifNo);
  if (data?.customerName) params.append("customerName", data.customerName);
  if (data?.status) params.append("status", data.status);

  return fetch({
    url: `/CollateralCustomer/search?${params.toString()}`,
    method: "get",
  });
};

CollateralCustomerService.getCollateralCustomerApprovalService = function (data) {
  const pageIndex = data.pageIndex ?? 0;
  const actualIndex = pageIndex > 0 ? pageIndex - 1 : 0;

  const params = new URLSearchParams();

  params.append("pageSize", data.pageSize ?? 10);
  params.append("pageIndex", actualIndex);

  if (data?.collateralId) params.append("collateralId", data.collateralId);
  if (data?.collateralType) params.append("collateralType", data.collateralType);
  if (data?.ownerName) params.append("ownerName", data.ownerName);
  if (data?.jenisPengikatan) params.append("jenisPengikatan", data.jenisPengikatan);
  if (data?.cifNo) params.append("cifNo", data.cifNo);
  if (data?.customerName) params.append("customerName", data.customerName);
  if (data?.status) params.append("status", data.status);

  return fetch({
    url: `/CollateralCustomer/approvalCollateralCustomer?${params.toString()}`,
    method: "get",
  });
};

CollateralCustomerService.putCollateralCustomerApprovalService = function (data) {
  return fetch({
    url: `/CollateralCustomer/approve`,
    method: "put",
    headers: {
        "x-requestId": data?.xRequest,
    },
    data: data?.data,
  });
};

// return
CollateralCustomerService.putCollateralCustomerReturnService = function (data) {
  return fetch({
    url: `/CollateralCustomer/return`,
    method: "put",
    headers: {
        "x-requestId": data?.xRequest,
    },
    data: data?.data,
  });
};

// return
CollateralCustomerService.deleteCollateralCustomerService = function (data) {
  return fetch({
    url: `/CollateralCustomer/delete`,
    method: "delete",
    headers: {
        "x-requestId": data?.xRequest,
    },
    data: data?.data,
  });
};

export default CollateralCustomerService;
